import React from 'react';
import { FilterBar, FilterReset, FilterSearch, FilterSelect } from '../../ui/FilterBar/FilterBar';
import type { FilterOption } from '../../ui/FilterBar/FilterBar';
import type { OrganizationStatusFilter } from '../../../types/access';

// const STATUS_OPTIONS: FilterOption<OrganizationStatusFilter>[] = [
//     { value: '', label: 'Все статусы' },
//     { value: 'active', label: 'Активные', dotColor: 'var(--status-ok)' },
//     { value: 'suspended', label: 'Приостановленные', dotColor: 'var(--color-danger)' },
// ];

interface OrganizationsFiltersProps {
    query: string;
    status: OrganizationStatusFilter;
    isFiltered: boolean;
    onQueryChange: (value: string) => void;
    onStatusChange: (value: OrganizationStatusFilter) => void;
    onReset: () => void;
}

export function OrganizationsFilters({
    query,
    status,
    isFiltered,
    onQueryChange,
    onStatusChange,
    onReset,
}: OrganizationsFiltersProps) {
    return (
        <FilterBar>
            <FilterSearch
                value={query}
                placeholder="Поиск по названию или ИНН"
                label="Поиск по организациям"
                onChange={onQueryChange}
            />

            {/* <FilterReset active={isFiltered} onClick={onReset} /> */}

            {/* <FilterSelect options={STATUS_OPTIONS} value={status} allValue="" onChange={onStatusChange} /> */}
        </FilterBar>
    );
}